module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_simple_cuad_4.0544158f.png";